import React from 'react';
import ProductListContainer from 'src/components/BeaconV2Components/MetricList/ProductListContainer';
import { Field } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';
import MetricListContainer from 'src/components/BeaconV2Components/MetricList/MetricListContainer';
import { getWeekColumnDefinition } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import { removeComparisonFormatter } from 'src/components/BeaconV2Components/MetricList/utils';

const fields: Field[] = [
  {
    name: 'retailSales',
    displayName: 'RETAIL\nSALES'
  },
  {
    name: 'unitsSold',
    displayName: 'UNITS\nSOLD'
  },
  {
    name: 'wholesaleSales',
    displayName: 'WHOLESALE\nSALES'
  },
  {
    name: 'retailPrice',
    displayName: 'RETAIL\nPRICE'
  },
  {
    name: 'returnRate',
    displayName: 'RETURN\nRATE %'
  },
  {
    name: 'unitsReturned',
    displayName: 'UNITS\nRETURNED'
  }
];

/**
 * Shows the units returned by product for the sales page
 */
const UnitsReturnedProductGrid = () => {
  const { isProductEntity } = useProductEntity();

  const weekEndingFields = fields.map(removeComparisonFormatter);

  return isProductEntity ? (
    <MetricListContainer
      entityTableHeaderProps={{
        title: 'Units Returned by Week'
      }}
      indexName="sales"
      sortFieldName="unitsReturned"
      fields={weekEndingFields}
      headColumnDefinition={getWeekColumnDefinition({
        getTableColumnProps(defaults) {
          return {
            ...defaults,
            style: {
              ...defaults.style,
              width: '220px'
            }
          };
        }
      })}
      postProcessData={(data) => {
        return data.sort((a, b) => b.weekId.localeCompare(a.weekId));
      }}
      useTableDataProps={{
        groupByFieldName: 'weekId',
        filterResponse: () => true,
        itemsPerPage: 100
      }}
      showGrid={false}
    />
  ) : (
    <ProductListContainer
      entityTableHeaderProps={{
        title: 'Units Returned by Product'
      }}
      indexName="sales"
      sortFieldName="unitsReturned"
      fields={fields}
    />
  );
};

export default UnitsReturnedProductGrid;
